$(function () {
    $('.show-password').hover(
        function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).parents('.input-group').find('input').attr('type', 'text');
        },
        function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).parents('.input-group').find('input').attr('type', 'password');
        }
    );
})
